import classNames from 'helpers/class-names'
import { FC, HTMLAttributes } from 'react'

interface Props extends HTMLAttributes<HTMLTableRowElement> {
  isSelected?: boolean
  disabled?: boolean
}

export const TableRow: FC<Props> = ({
  isSelected = false,
  disabled = false,
  children,
  ...props
}) => (
  <tr
    {...props}
    data-selected={isSelected}
    className={classNames(
      'group relative border-b border-gray-50',
      {
        'hover:cursor-pointer':
          typeof props.onClick !== 'undefined' && !disabled,
      },
      {
        'hover:cursor-not-allowed': disabled,
      },
      props.className,
    )}>
    {children}
  </tr>
)
